import { forwardRef } from 'react';
import { Box, Button, Link, Stack, Typography, colorsPalette, styled } from '@lingoda/ui';
import { GlobeIcon24 } from '@lingoda/ui/icons/lingodaIcons';
import { Close as CloseIcon } from '@lingoda/ui/icons';
import { trans } from '@lingoda/i18n';
import { SettingsPages, studentSettingsPath } from '@lingoda/router';
import { setDismissForTimezone } from './utils';

interface Props {
    dismissBar: () => void;
    localTimezone: string;
}

export const TimezoneDifferencesBar = forwardRef<HTMLDivElement, Props>(
    ({ dismissBar, localTimezone }, ref) => {
        const onClose = () => {
            setDismissForTimezone(localTimezone);
            dismissBar();
        };

        return (
            <BarBgStyled ref={ref}>
                <InfoStyled spacing={2} direction="row">
                    <IconWrapperStyled>
                        <GlobeIcon24 />
                    </IconWrapperStyled>
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                        <Box mr={1}>
                            <InfoTypographyStyled variant="subtitle1">
                                {trans('timezone-shift-detected', {}, 'student-common')}
                            </InfoTypographyStyled>
                        </Box>

                        <Link to={studentSettingsPath({ page: SettingsPages.TimeAndLanguage })}>
                            {trans('sync-my-timezone', {}, 'student-common')}
                        </Link>
                    </Stack>
                </InfoStyled>
                <CloseButton onClick={onClose} size="small">
                    <CloseIcon />
                </CloseButton>
            </BarBgStyled>
        );
    },
);

TimezoneDifferencesBar.displayName = 'TimezoneDifferencesBar';

const BarBgStyled = styled(Box)(({ theme }) => ({
    backgroundColor: colorsPalette.infoSolid[12],
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    padding: theme.spacing(3),
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2),
    },
}));

const InfoStyled = styled(Stack)({
    height: '100%',
    alignItems: 'flex-start',
});

const InfoTypographyStyled = styled(Typography)({
    color: colorsPalette.infoCustom.extradark,
});

const IconWrapperStyled = styled(Box)({
    display: 'flex',
    color: colorsPalette.infoSolid[100],
});

const CloseButton = styled(Button)({
    color: colorsPalette.blackAlpha[70],
    padding: 0,
});
